// extracted by mini-css-extract-plugin
export default {"getInTouch":"ContactSection_getInTouch__aCe6G"};